import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../libs'
import {
  BalanceOperation,
  BalanceOperationRequest,
  BalanceOperationResponse,
} from './types'

export const balanceOperationListMounted =
  createEvent<BalanceOperationRequest>()

export const getBalanceOperations = fx<
  BalanceOperationRequest,
  BalanceOperationResponse
>({
  method: 'GET',
  url: `/balance_operation`,
})

export const $balanceOperations = restore<BalanceOperation[]>(
  getBalanceOperations.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfBalanceOperations = restore(
  getBalanceOperations.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: balanceOperationListMounted,
  fn: ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    searchedColumn,
    filters,
  }) => {
    if (orderDirection == 'descend') {
      orderDirection = '-'
    } else if (orderDirection == 'ascend') {
      orderDirection = ''
    }
    let query = {
      limit,
      page,
    }

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    if (filters) {
      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      const newFilters = {
        ...filters,
      }

      let newObj = Object.keys(newFilters).reduce((accumulator, key) => {
        if (filters[key as keyof typeof filters] != null) {
          accumulator[key as keyof typeof filters] =
            key === 'country'
              ? filters[key as keyof typeof filters]
              : `${filters[key as keyof typeof filters]}`
        }

        return accumulator
      }, {} as any)

      if (searchText) {
        newObj[searchedColumn] = searchText.toLowerCase()
      }

      // @ts-ignore
      query['where'] = `${JSON.stringify(newObj)}`
    }

    return {
      query,
    }
  },
  target: getBalanceOperations,
})
